import type { ReactNode } from "react";

/**
 * Feature 横断の Context 配布場所（必要になったらここに追加）。
 * 現状は Zustand のみを状態管理に使用しているため中身は空。
 */
export function FeatureProviders({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
